import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-148" data-mp="1iw341efukb5e">
      <div className="mx-auto max-w-6xl px-4" data-id="element-149" data-mp="1dxjfr7ds6n9v">
        <div className="text-center" data-id="element-150" data-mp="1dunk5ppeoaol">
          <span className="inline-flex items-center gap-2 rounded-md bg-field px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-gold" data-id="element-151" data-mp="2bkij20yzatgq">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-152" data-mp="26j2tbvluvys0" /> Los {totalVolumes} tomos
          </span>
          <h2 id="modules-title" className="mx-auto mt-4 max-w-3xl text-balance text-3xl font-extrabold text-field sm:text-4xl" data-id="element-153" data-mp="21nvyzeeh86fr">
            Una guía completa por cada dimensión de los Yacimientos de Hidrocarburos
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-154" data-mp="l6rp0pfhiqtx">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-xl border border-line bg-white p-6 text-ink shadow-card" data-id="element-155" data-mp="1nubl6nhoqgxo" data-mpi={index}>
                <div className="flex items-start justify-between gap-4" data-id="element-156" data-mp="14wsdbn6yr4cu">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-field text-gold" data-id="element-157" data-mp="q7w3plp9dja4">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-158" data-mp="v65yvwazgjvq" />
                  </span>
                  <span className="font-display text-xs font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-159" data-mp="h76b0qvao90m">
                    Tomo {module.number}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-extrabold leading-tight text-field" data-id="element-160" data-mp="2nux8dmcja4ry">{module.title}</h3>
                <p className="mt-2 text-sm font-semibold text-earth" data-id="element-161" data-mp="2j1ud99s3yn9n">{module.subtitle}</p>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-162" data-mp="2e53x6mgazro8">{module.description}</p>
                <p className="mt-4 flex-1 rounded-lg border-l-4 border-field bg-field-tint p-3 text-sm leading-relaxed text-ink" data-id="element-163" data-mp="296am10ohocr8">
                  <b className="font-extrabold text-field" data-id="element-164" data-mp="36qx4988mtsgt">Resultado: </b>
                  {module.result}
                </p>
                <div className="mt-auto flex flex-col gap-3 border-t border-line pt-4" data-id="element-165" data-mp="2wutubg7jgpjb">
                  <span className="inline-flex items-center gap-1.5 self-start rounded-md bg-gold-soft px-3 py-1 text-xs font-extrabold text-earth-dark" data-id="element-166" data-mp="2wwoakh7v7th2">
                    <FileTextIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1lgg5o94yo628" /> {module.note}
                  </span>
                  <p className="text-[10px] font-extrabold uppercase tracking-[.1em] text-muted" data-id="element-168" data-mp="1hcry3qgbxagz">{module.tags}</p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border-b-4 border-earth bg-field px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-169" data-mp="y5ogm310q36">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-170" data-mp="anp6xqmtuhxi">Total de la colección principal</p>
          <p className="font-display text-2xl font-extrabold text-cream sm:text-3xl" data-id="element-171" data-mp="flqryh3tcrbm">
            {totalVolumes} tomos <span className="mx-2 text-gold" data-id="element-172" data-mp="kk226sy0t3ud">·</span> Contenido normativo actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}